<template>
    <footer class="footer footer-layout1 text-center bg-dark">
      <div class="footer-top">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-12">
              <img id="logoFooterImage"  src="../../assets/images/losplatoslogo-dark.png">
              <div class=" col-12">
             <p class="mx-2 mb-20">Creado por losplatos.es. Crea tu menú aquí</p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
    name: 'HomeFooter',
    props: ['menu']
}
</script>


<style scoped>
  #logoFooterImage {
    width: 150px;
  }
  .footer {
    margin-top: 20px;
  }
</style>